import type { StoreInformation } from "@api/orders/types/order-summary";
import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
} from "react";

type StoreInfoCtxType = {
  storeInfo: StoreInformation;
  setStoreInfo: Dispatch<SetStateAction<StoreInformation>>;
};

export const StoreInfoCtx = createContext<StoreInfoCtxType>({
  storeInfo: {},
  setStoreInfo: () => {},
});

export function StoreInfoProvider(props: PropsWithChildren) {
  const [storeInfo, setStoreInfo] = useState<StoreInformation>({});

  return (
    <StoreInfoCtx.Provider value={{ storeInfo, setStoreInfo }} {...props} />
  );
}

export function useStoreInfoCtx() {
  const storeInfo = useContext(StoreInfoCtx);

  if (!storeInfo) {
    throw new Error("useStoreInfoCtx must be used within a StoreInfoProvider");
  }

  return storeInfo;
}
